import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { SELECTOR_STYLE } from '@common'
import './ProductVariantSelector.css'

const formatOptionLabel = ({ label, sellPrice, isDisabled }, { context }) => {
    if (context === 'menu') {
        return (
            <div style={{ display: 'flex', gap: '32px', justifyContent: 'space-between' }}>
                <span>{label}</span>
                {isDisabled ?
                    <span className="disabled text-danger">Sold Out</span>
                :   <span>${sellPrice?.toFixed(2)}</span>}
            </div>
        )
    }
    return label
}

const ProductVariantSelector = ({ variants, value, onChange, onOpen }) => {
    if (!variants || variants.length === 0) return null

    if (variants.length === 1) {
        if (variants[0].label === 'Default Title') {
            return null
        }

        return (
            <div className="product-variant-selector">
                <h6 className="variant-title">Variant</h6>
                <p>{variants[0].label}</p>
            </div>
        )
    }

    return (
        <div className="product-variant-selector">
            <h6 className="variant-title">
                Select one of the following <span className="required-mark">*</span>
            </h6>
            <Select
                value={value}
                options={variants}
                onChange={onChange}
                onMenuOpen={onOpen}
                placeholder="Select Variant"
                formatOptionLabel={formatOptionLabel}
                styles={SELECTOR_STYLE}
                isSearchable={false}
            />
        </div>
    )
}

ProductVariantSelector.propTypes = {
    variants: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default ProductVariantSelector
